<template>
	<div>
		<div class="card mb-3" v-if="eventPromoted">
			<div class="card-body">
				<h5>Cortesías disponibles</h5>

				<table class="table table-sm mt-4">
					<tr class="table-head">
						<td>Tipo de entrada</td>
						<td>Disponibilidad</td>
						<td class="text-right">Enlace de invitación</td>
					</tr>

					<tr v-for="ticketCourtesy of eventPromoted.ticketsCourtesy" :key="ticketCourtesy.id">
						<td>
							<div class="tc">
								{{ ticketCourtesy.ticketType.name }} - {{ ticketCourtesy.ticketType.ticketGroup.name }}
							</div>
						</td>
						<td>
							<div class="tc">{{ ticketCourtesy.available }} de {{ ticketCourtesy.total }}</div>
						</td>
						<td class="text-right">
							<div @click="copyLink(ticketCourtesy)" class=" ml-auto btn btn-secondary btn-xs ">
								<template v-if="ticketCourtesy.copied"
									><i class="icon-check mr-2" /> Enlace copiado</template
								>
								<template v-else><i class="icon-clone mr-2" /> Enlace de invitación</template>
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>

		<b-modal
			id="eventTicketCourtesyModal"
			title="Enviar ticket de cortesía"
			no-close-on-backdrop
			hide-footer
			@close="close()"
		>
			<FormulateForm v-model="form" ref="form" @submit="save">
				<div class="py-3">
					<FormulateInput
						label="Tipo de ticket"
						name="ticketTypeId"
						type="selectSearch"
						:options="eventTicketTypes"
						validation-name="Tipo de ticket"
						validation="required"
						optionValue="id"
						optionText="name"
					/>

					<div class="label">Datos de receptor</div>
					<div class="row row-xs">
						<div class="col-6">
							<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />
						</div>
						<div class="col-6">
							<FormulateInput
								label="Apellido"
								name="lastname"
								validation-name="Apellido"
								validation="required"
							/>
						</div>
					</div>

					<div class="mt-2">
						<FormulateInput
							label="Email"
							type="email"
							name="email"
							validation-name="Email"
							validation="required"
						/>
					</div>
				</div>

				<hr />
				<div class="d-flex justify-content-between mt-4">
					<div class="btn btn-secondary" @click="close">
						Cancelar
					</div>
					<button type="submit" class="btn btn-primary">
						<span v-if="saving">Enviando <span class="btn-loader" /> </span>
						<span v-else>Enviar cortesía</span>
					</button>
				</div>
			</FormulateForm>
		</b-modal>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/Loader"

export default {
	name: "CourtesyTicketsInvite",
	components: {
		Loader
	},
	props: {
		userId: {
			type: String,
			required: true
		},
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			tickets: [],
			loading: true,
			saving: false,
			eventPromoted: null,
			form: {
				name: null,
				lastname: null,
				email: null
			}
		}
	},
	beforeMount() {
		this.load()
	},
	computed: {
		courtesyToSend() {
			return this.tickets.filter((ticket) => ticket.type == "COURTESY" && ticket.holder == null)
		},
		eventTicketTypes() {
			let ticketTypes = []
			this.tickets.forEach((ticket) => {
				if (ticketTypes.find((type) => type.id == ticket.ticketType.id) == null) {
					ticketTypes.push({
						id: ticket.ticketType.id,
						name: ticket.ticketType.ticketGroup.name + " - " + ticket.ticketType.name
					})
				}
			})
			return ticketTypes
		}
	},
	methods: {
		copyLink(ticketCourtesy) {
			const link = ticketCourtesy.invitationLink
			const itemIndex = this.eventPromoted.ticketsCourtesy.findIndex(
				(ticket) => ticket.ticketType.id == ticketCourtesy.ticketType.id
			)
			const clipboardData =
				event.clipboardData || window.clipboardData || event.originalEvent?.clipboardData || navigator.clipboard

			this.eventPromoted.ticketsCourtesy[itemIndex].copied = true

			clipboardData.writeText(link)

			setTimeout(() => {
				this.eventPromoted.ticketsCourtesy[itemIndex].copied = false
			}, 3000)
		},
		async open() {
			this.$bvModal.show("eventTicketCourtesyModal")
		},
		close() {
			this.$bvModal.hide("eventTicketCourtesyModal")
			this.form = {
				name: null,
				email: null
			}
		},
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($eventId: ID!, $userId: ID!) {
							eventPromotedCourtesies(eventId: $eventId, userId: $userId) {
								event {
									id
									code
									name
									startAt
									image {
										id
										url
										urlThumb
									}
									status
								}
								ticketsCourtesy {
									ticketType {
										id
										name
										ticketGroup {
											id
											name
										}
									}
									invitationLink
									available
									total
								}
							}
						}
					`,
					variables: {
						userId: this.userId,
						eventId: this.eventId
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.eventPromoted = {
						...data.eventPromotedCourtesies,
						ticketsCourtesy: data.eventPromotedCourtesies.ticketsCourtesy.map((ticket) => {
							return {
								...ticket,
								copied: false
							}
						})
					}

					this.loading = false
				})
		},

		async save() {
			if (!this.saving) {
				this.saving = true

				// segun el ticketType seleccionado, busco alguno de los tickets pendientes con ese mismo ticketType
				let ticket = this.courtesyToSend.find((ticket) => ticket.ticketType.id == this.form.ticketTypeId)

				let dataHolder = {
					name: this.form.name,
					lastname: this.form.lastname,
					email: this.form.email
				}
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!, $data: TicketCourtesyHolderInput!) {
								ticketCourtesyHolderAssign(id: $id, data: $data)
							}
						`,
						variables: {
							id: ticket.id,
							data: dataHolder
						},
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						this.$toast.success("Ticket de cortesía enviado correctamente")
						this.saving = false

						this.$emit("updated")
						this.close()
					})
					.catch((err) => {
						this.parseGQLErrors(err)
						this.saving = false
					})
			}
		}

		// async create(data) {
		// },
	}
}
</script>

<style scoped lang="scss">
.icon-tabler-ticket {
	width: 48px;
	height: 48px;
}
</style>
